import { faBriefcase, faChartMixed } from "@fortawesome/pro-regular-svg-icons";
import { useLocation } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";

import { useCaseAnalyticsAccess } from "src/cases/analytics/useCaseAnalyticsAccess";
import { useCaseInsightsAccess } from "src/cases/analytics/useCaseInsightsAccess";
import { CaseTemplatesNavSection } from "src/cases/templates/CaseTemplatesNavSection";
import { useCapabilities } from "src/hooks/useCapabilities";
import { NavItem, NavSidebar } from "src/layout/NavSideBar";
import {
  DashboardPageParams,
  getUrlToCaseAnalyticsPage,
  getUrlToCaseQueuePage,
} from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const CaseNavSidebar: React.FC = () => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
  const { caseAnalytics, caseTemplates } = useCapabilities();
  const { canAccess: caseAnalyticsEnabled } = useCaseAnalyticsAccess();
  const { canAccess: canAccessCaseInsights } = useCaseInsightsAccess();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useLocalStorage(
    "caseNavigationCollapsed",
    false,
  );

  if (
    !caseAnalyticsEnabled ||
    (!caseAnalytics.canAccess && !caseTemplates.canAccess)
  ) {
    return null;
  }

  const isQueuesPage =
    !pathname.includes("/analytics") && !pathname.includes("/templates");

  return (
    <div className="border-gray-100 border-l">
      <NavSidebar collapsed={collapsed} setCollapsed={setCollapsed}>
        {canAccessCaseInsights && (
          <NavItem
            dataLoc="case-analytics"
            icon={faChartMixed}
            title="Case Insights"
            to={getUrlToCaseAnalyticsPage(orgId, wsId)}
          />
        )}
        <NavItem
          dataLoc="case-queues"
          icon={faBriefcase}
          isActiveOverride={isQueuesPage}
          neverShowActive
          title="Queues"
          to={getUrlToCaseQueuePage({ orgId, wsId })}
        />
        {caseTemplates.canAccess && (
          <CaseTemplatesNavSection
            canCreate={caseTemplates.canCreate}
            collapsed={collapsed}
            orgId={orgId}
            wsId={wsId}
          />
        )}
      </NavSidebar>
    </div>
  );
};
